<template>
    <div class="session-expired-container">
        <img
            src="../../assets/img/session-expired.png"
            alt="Sessão expirada"
            class="session-expired-img" />
        <div class="session-expired-content">
            <h1 class="title">Sua sessão expirou.</h1>
            <p class="subtitle">Faça login novamente em outra aba para continuar.</p>
            <p class="subtitle">Certifique-se de que os cookies estejam habilitados.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SessionExpired',
    }
</script>